import React, { useEffect } from "react";
import { ToastBox } from "./ToastStyles";

function Toast({ timeout = 7, message, setMessage }) {
  useEffect(() => {
    if (message) {
      const ms = timeout * 1000; // timeout em milissegundos

      setTimeout(() => {
        setMessage(""); // limpa mensagem
      }, ms);
    }
  }, [message]); // eslint-disable-line

  if (!message) return <></>;

  return (
    <ToastBox>
      <p>{message}</p>
    </ToastBox>
  );
}

export default Toast;
